import React from 'react';
import PropTypes from 'prop-types';

import styles from './HelperText.module.css';

const HelperText = React.forwardRef((props, ref) => (
    <div ref={ref} className={styles.helperText}>
        {props.children}
    </div>
));

HelperText.displayName = 'HelperText';

HelperText.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HelperText;
